export const enum DocumentSlots {
  Statuses = 'DOCUMENTS_STATUSES',
  EntityDetails = 'DOCUMENTS_ENTITY_DETAILS',
  Information = 'DOCUMENTS_INFORMATION',
  Details = 'DOCUMENTS_DETAILS',
  BottomInfoLeft = 'DOCUMENT_BOTTOM_INFO_LEFT',
  BottomInfoRight = 'DOCUMENT_BOTTOM_INFO_RIGHT',

  //Document history versions modal
  VersionTitle = 'DOCUMENT_VERSION_TITLE',
  VersionLeft = 'DOCUMENT_VERSION_LEFT',
  VersionRight = 'DOCUMENT_VERSION_RIGHT',
}
